import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LoanPropertyListSF from '../util/LoanPropertyListSF'

const InterestRateUI = ({ context, loan, loanInterestRate, onRefreshClick }) =>
  <div>
    <LRTableActionsUI location='top'
        left={
            <div className='g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <span className='g_m_left_100 g_large'><b>Interest rate</b></span>
            </div>
        }
        right={<span />}
    />

    <LoanPropertyListSF context={context} loan={loan} category='interest_rate' categoryLabel='Interest rate parameters' />

    <InterestRateAssessmentTableUI
        context={context}
        loanInterestRate={loanInterestRate}
        onRefreshClick={onRefreshClick}
    />
  </div>

const InterestRateAssessmentTableUI = ({ loanInterestRate }) =>
    <CardUI className='g_m_top_100' title='Interest rate assessment'>
        <table className='g_table'>
            <thead className='g_sticky'><tr>
                <td className='g_text_center'><b>Particular</b></td>
                <td className='g_text_center'><b>Clime Loan</b></td>
            </tr></thead>
            <tbody>
                {
                    loanInterestRate &&
                    <>
                        <Row2UI
                            lir='opportunityCost'
                            value={loanInterestRate.opportunityCostRate}
                        />
                        <Row2UI
                            lir='cost'
                            value={loanInterestRate.costIncurredRate}
                        />
                        <Row2UI
                            lir='baseRate'
                            value={loanInterestRate.baseRate}
                        />
                        <Row2UI
                            lir='spread'
                            value={loanInterestRate.spreadRate}
                        />
                        <Row2UI
                            lir='reduction'
                            value={loanInterestRate.dsraReductionRate}
                        />
                        <Row2UI
                            lir='minimumLendingRate'
                            value={loanInterestRate.minimumRate}
                            total={true}
                        />
                        <tr><td colSpan='8'><b>Additions to interest rate</b></td></tr>
                        <Row2UI
                            lir='securityCover'
                            value={loanInterestRate.securityCoverRate}
                        />
                        <Row2UI
                            lir='tenorPremium'
                            value={loanInterestRate.tenorPreminumRate}
                        />
                        <Row2UI
                            lir='escrowCoverage'
                            value={loanInterestRate.escrowCoverageRate}
                        />
                        <Row2UI
                            lir='ratingPremium'
                            value={loanInterestRate.ratingPremiumRate}
                        />
                        <Row2UI
                            lir='womenStakeholder'
                            value={loanInterestRate.womenStakeHolderRate}
                        />
                        <Row2UI
                            lir='ppaRebateRate'
                            value={loanInterestRate.ppaRebateRate}
                        />
                        <Row2UI
                            lir='repeatTxnRebateRate'
                            value={loanInterestRate.repeatTxnRebateRate}
                        />
                        <Row2UI
                            lir='cashFlowRebateRate'
                            value={loanInterestRate.cashFlowRebateRate}
                        />
                        <Row2UI
                            lir='finalRate'
                            value={loanInterestRate.finalRate}
                        />
                    </>
                }
            </tbody>
        </table>
    </CardUI>

const Row2UI = ({ lir, value, total, }) =>
    <>
        <tr className={total && 'g_table_total'}>
            <td>
                <Desc lir={lir} />
            </td>
            {
                value &&
                <td className='g_text_right'>
                    {value}%
                </td>
            }
            {
                value === null &&
                <td className='g_text_right'></td>
            }
        </tr>
    </>

const Desc = ({ lir }) =>
  <span>
    {(() => {
      switch (lir) {
        case 'dsra':
            return 'Security - DSRA'
        case 'residualValue':
            return 'Security - Residual Value'
        case 'charge':
            return 'Security - Charge on current & movable assets'
        case 'total':
            return 'Total'
        case 'loanAmountApproved':
            return 'Loan Amount Approved'
        case 'cover':
            return 'Cover'
        case 'opportunityCost':
            return 'Opportunity Cost (Risk free FD interest rate)'
        case 'cost':
            return 'Cost to be incurred by Clime'
        case 'baseRate':
            return 'Base Rate'
        case 'spread':
            return 'Spread'
        case 'reduction':
            return 'Reduction on account on DSRA*'
        case 'minimumLendingRate':
            return 'Minimum lending rate to be charged from clients'
        case 'securityCover':
            return 'Security Cover'
        case 'tenorPremium':
            return 'Tenor Premium for > 12 months deal'
        case 'escrowCoverage':
            return 'Escrow Coverage'
        case 'ratingPremium':
            return 'Rating Premium'
        case 'womenStakeholder':
            return 'Women stakeholder'
        case 'ppaRebateRate':
            return 'Rebate for "A" rated or above counterparty (in PPA only)'
        case 'repeatTxnRebateRate':
            return 'Rebate for Repeat Transaction'
        case 'cashFlowRebateRate':
            return 'Rebate for contracted cashflow'
        case 'finalRate':
            return 'Final rate'
        default:
            return lir
      }
    })()}
  </span>

export default InterestRateUI
